import {
	AfterViewInit,
	ChangeDetectorRef,
	Injectable,
	Injector,
	Input,
	NgZone,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
} from '@angular/core';

import {
	forEach,
	map,
	remove,
} from 'lodash';

import { Observable } from 'rxjs';

import { CommonLocaleService } from '../services/locale/locale.service';

@Injectable()
export class CommonBaseComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@Input() modifiers = '';

	protected localeService: CommonLocaleService = this.injector.get(CommonLocaleService);
	protected changeDetector: ChangeDetectorRef = this.injector.get(ChangeDetectorRef);
	protected zone: NgZone = this.injector.get(NgZone);

	protected modifierSeparator = '--';
	protected classesSeparator = ' ';
	protected needUnbind: CallableFunction[] = [];

	constructor (
		protected injector: Injector,
	) {}

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle, @angular-eslint/no-empty-lifecycle-method
	ngOnInit () {
		// Empty
	}

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle, @angular-eslint/no-empty-lifecycle-method,@typescript-eslint/no-unused-vars
	ngOnChanges (changes: SimpleChanges) {
		// Empty
	}

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle, @angular-eslint/no-empty-lifecycle-method
	ngAfterViewInit () {
		// Empty
	}

	ngOnDestroy () {
		forEach(this.needUnbind, (callback) => {
			callback();
		});
	}

	instant (key: string, params?: object): string {
		return this.localeService.instant(key, params);
	}

	protected getBaseClasses (cssBaseClass: string): string[] {
		const classes = [cssBaseClass];

		if (this.modifiers.length) {
			const modifiers = this.modifiers.split(this.classesSeparator);
			const modifierClasses = map(modifiers, (modifier) => cssBaseClass + this.modifierSeparator + modifier);

			return classes.concat(modifierClasses);

		} else {
			return classes;
		}
	}

	protected getBaseClassesAsString (cssBaseClass: string): string {
		return this.getBaseClasses(cssBaseClass).join(this.classesSeparator);
	}

	// Timeout with additional functional
	// The third argument it is possible to transfer function which of all is performed in case of completion of the timer
	// Returns canceling function
	protected timeout (
		func: CallableFunction = (): void => void (0),
		time = 0,
		finallyFunc: CallableFunction = (): void => void (0),
	): CallableFunction {
		const timer = setTimeout(() => {
			func();
			finallyFunc();
		}, time);

		return () => {
			clearTimeout(timer);
			finallyFunc();
		};
	}

	protected willUnbind (callback: () => void): (withUnbind?: boolean) => void {
		this.needUnbind.push(callback);

		return (withUnbind = false): void => {
			remove(this.needUnbind, (f) => f === callback);

			if (withUnbind) {
				callback();
			}
		};
	}

	protected runUpdate () {
		this.changeDetector.markForCheck();
	}

	protected runOutsideAngular<T> (func: (...args: any[]) => T): T {
		return this.zone.runOutsideAngular(func);
	}

	protected subscribe (observable: Observable<any>, observerOrNext: any): void;
	protected subscribe<T> (observable: Observable<T>, observerOrNext: (value: T) => void, error?: (error: any) => void ): void;
	protected subscribe<T> (observable: Observable<T>, observerOrNext: (value: T) => void, error?: (error: any) => void, complete?: () => void ): void {
		const subscription = observable.subscribe(observerOrNext, error, complete);

		this.willUnbind(() => {
			subscription.unsubscribe();
		});
	}
}
